import icon_china_flag from '@/assets/icons/icon_china_flag.svg';

export const USER_INFO_STORAGE_KEY = 'userInfo'; // 用户信息持久化存储键名



// 定义左侧菜单项
export const manageMenuItems = [
    {
        key: 'overview',
        label: '总览',
    },
    {
        key: 'billing',
        label: '积分流水',
    },
    // {
    //     key: 'management',
    //     label: '套餐管理',
    // },
    {
        key: 'account',
        label: '账户信息',
    },
    // {
    //     key: 'invoice',
    //     label: '账单发票',
    // },
    {
        key: 'invitation-rewards',
        label: '邀请奖励',
    },
];


// 语言配置数组
export const languageOptions = [
    { key: 'zh', text: '中文', iconSrc: icon_china_flag },
    // { key: 'en', text: '英文', iconSrc: icon.icon_usa_flag },
];

// 错误消息
export const ERROR_MESSAGES = {
  EMPTY_ACCOUNT: "账号不能为空",
  EMPTY_PASSWORD: "密码不能为空",
  NETWORK_ERROR: "网络问题，稍后再试",
  INVALID_PHONE: "请输入有效的手机号"
};

// 流水类型
export const BillingTypeEunm = {
    DEDUCT: 3, // 扣费流水
    FREEZE: 2, // 冻结流水
    RELEASE: 4, // 返还流水
    RECHARGE: 1, // 充值流水
    EXPIRE: 5, // 过期流水
    GIFT: 0, // 赠送流水
    REFUND: 6, // 退款流水  
}

export const BusinessTypeEnum = {
    SC: "sc", // 空间计算
    SC_EXPORT: "sc_export", // 空间计算数据导出
    FORMAT_CONVERT: "format_convert", // 格式转换
    DSM_DOM: "dsm_dom", // DSM / DOM
    DENSE_POINTCLOUD: "dense_pointcloud", // 稠密点云
    MESH: "mesh", // MESH（OBJ / OSGB）
    GS_SELF: "3dgs_self", // 3DGS（自有）
    GS_GAODE: "3dgs_gaode", // 3DGS（高德云镜高斯）
    GS_THIRD: "3dgs_third", // 3DGS（第三方）
    TEXT_TO_MODEL: "text-to-model", // 文生材质模型
    TEXT_TO_MESH: "text-to-mesh", // 文生网格模型
    IMAGE_TO_MODEL: "image-to-model", // 图生材质模型
    IMAGE_TO_MESH: "image-to-mesh", // 图生网格模型
};
// 业务类型 → 中文描述
export const BusinessTypeMap = {
    "sc": "空间计算",
    "sc_export": "空间计算数据导出",
    "format_convert": "格式转换",
    "dsm_dom": "DSM / DOM",
    "dense_pointcloud": "稠密点云",
    "mesh": "MESH（OBJ / OSGB）",
    "3dgs_self": "3DGS（自有）",
    "3dgs_gaode": "3DGS（高德云镜高斯）",
    "3dgs_third": "3DGS（第三方）",
    "text-to-model": "文生材质模型",
    "text-to-mesh": "文生网格模型",
    "image-to-model": "图生材质模型",
    "image-to-mesh": "图生网格模型",
};

// 用户套餐类型
export const LevelEnum = {  
    FREE: 0, // 体验版
    PRO: 1, // 专业版
}

// 产品 spu（商品品类）
export const SpuEnum = {
    FREE: 1,      // 免费版
    PRO: 2,       // 专业版
    ENTERPRISE: 3,// 企业版
    EXTRA: 4,     // 加量包
}

// 产品 sku（按年 / 按月 / 按日）
export const SkuEnum = {
    YEAR: 1,      // 年付
    MONTH: 2,     // 月付
    DAY: 3,       // 日付
}

// 订单状态
export const OrderStatusEnum = {
    PENDING: 1, // 待支付
    PROCESS: 2, // 处理中
    SUCCESS: 3, // 已完成
    CANCELED: 4, // 已取消
}

// 订单发票状态
export const InvoiceStatusEnum = {
    NOT: 0, // 未开票
    PROCESS: 1, // 开票中
    SUCCESS: 2, // 已开票
}

// 发票类型（值直接对应 API 的 invoice_type）
export const InvoiceTypeEnum = {
    ELECTRONIC: 1, // 电子普通发票
    SPECIAL: 2,    // 增值税专用发票
};

// 抬头类型（值直接对应 API 的 title_type）
export const TitleTypeEnum = {
    PERSONAL: 1, // 个人/非企业单位
    COMPANY: 2,  // 企业/事业单位
};

/** 世界模型区块统一横向留白（与 LargeSpatialBuild 大图容器一致） */
export const WORLD_MODEL_SECTION_PX =
    'px-6 md:px-12 lg:px-20 xl:px-32 2xl:px-60';

/** 世界模型区块统一内容最大宽度（与 LargeSpatialBuild 大图一致） */
export const WORLD_MODEL_CONTENT_WIDTH =
    'w-full max-w-[56.25rem] lg:max-w-[70rem] xl:max-w-[80rem] 2xl:max-w-[90rem]';

/** 居中内容通道：左右边界与大图对齐 */
export const WORLD_MODEL_CONTENT_LANE = `mx-auto ${WORLD_MODEL_CONTENT_WIDTH}`;

/** 固定 Header 高度，滚动锚点需减去该值 */
export const HEADER_HEIGHT = 100;
